"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Fade;

var _react = _interopRequireDefault(require("react"));

var _gatsbyPluginTransitionLink = _interopRequireDefault(require("gatsby-plugin-transition-link"));

var _gsap = require("gsap");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fade = function fade(_ref) {
  var length = _ref.exit.length,
      node = _ref.node,
      direction = _ref.direction;
  var duration = direction === "out" ? length + length / 4 : length;
  var opacity = direction === "in" ? 1 : 0;
  return new _gsap.TimelineMax().fromTo(node, duration, {
    opacity: !opacity
  }, {
    opacity: opacity
  });
};

function Fade(props) {
  var length = props.length || 0.4;
  return _react.default.createElement(_gatsbyPluginTransitionLink.default, {
    to: props.to,
    exit: {
      length: length,
      trigger: function trigger(_ref2) {
        var exit = _ref2.exit,
            node = _ref2.node;
        return fade({
          exit: exit,
          node: node,
          direction: "out"
        });
      }
    },
    entry: {
      length: length,
      trigger: function trigger(_ref3) {
        var exit = _ref3.exit,
            node = _ref3.node;
        return fade({
          exit: exit,
          node: node,
          direction: "in"
        });
      }
    }
  }, props.children);
}